module.exports = __webpack_public_path__ + "img/TX.0d7c0341.png";